import { useState } from "react";
import { ContainerBox, Shimmer } from "../ShimmerEffect";

function ImageLoader({
  src,
  className,
  alt = "",
  imageHeight = "100%",
  imageWidth = "100%",
}) {
  const [imgLoaded, setImgLoaded] = useState(false);
  return (
    <div>
      <Shimmer
        loading={!imgLoaded}
        loadingComponent={
          <ContainerBox width={imageWidth} height={imageHeight} />
        }
        renderComponent={
          <img
            src={src}
            className={className}
            alt={alt}
            onLoad={() => setImgLoaded(true)}
          />
        }
      />
      <img
        style={{
          position: "absolute",
          left: 0,
          top: 0,
          visibility: "hidden",
        }}
        src={src}
        className={className}
        alt={alt}
        onLoad={() => setImgLoaded(true)}
      />
    </div>
  );
}

export default ImageLoader;
